<template>
  <div class="panel-card">
    <div class="panel-card__header">
      <h3 class="panel-card__title">
        {{ $t('OPPORTUNITY_DASHBOARD.LOSS_REASONS.TITLE') }}
      </h3>
      <div v-if="lossReasons.length" class="toggle-group">
        <button
          class="toggle-group__option"
          :class="{ 'toggle-group__option--active': mode === 'count' }"
          @click="mode = 'count'"
        >
          {{ $t('OPPORTUNITY_DASHBOARD.STAGE_FUNNEL.QUANTITY') }}
        </button>
        <button
          class="toggle-group__option"
          :class="{ 'toggle-group__option--active': mode === 'value' }"
          @click="mode = 'value'"
        >
          {{ $t('OPPORTUNITY_DASHBOARD.STAGE_FUNNEL.VALUE') }}
        </button>
      </div>
    </div>

    <opportunity-dashboard-loss-reasons-chart
      v-if="lossReasons.length"
      :loss-reasons="lossReasons"
      :mode="mode"
      :currency="currency"
    />
    <div v-else class="loss-reasons-empty">
      <img :src="celebrationImage" alt="" class="loss-reasons-empty__image" />
      <div>
        <p class="loss-reasons-empty__title">
          {{ $t('OPPORTUNITY_DASHBOARD.LOSS_REASONS.EMPTY_TITLE') }}
        </p>
        <p class="loss-reasons-empty__message">
          {{ $t('OPPORTUNITY_DASHBOARD.LOSS_REASONS.EMPTY_MESSAGE') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import OpportunityDashboardLossReasonsChart from './OpportunityDashboardLossReasonsChart.vue';
import celebrationImage from '../../../../../assets/images/opportunity-pipelines/finish-success.svg';

export default {
  components: { OpportunityDashboardLossReasonsChart },
  props: {
    lossReasons: { type: Array, default: () => [] },
    currency: { type: String, default: 'BRL' },
  },
  data() {
    return { mode: 'count', celebrationImage };
  },
};
</script>

<style scoped lang="scss">
.panel-card {
  background: var(--white);
  border: 1px solid var(--s-100);
  border-radius: var(--border-radius-large);
  padding: var(--space-normal);
}

.panel-card__header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--space-normal);
}

.panel-card__title {
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-bold);
  margin: 0;
}

.toggle-group {
  background: var(--s-25);
  border-radius: var(--border-radius-medium);
  display: flex;
  padding: var(--space-micro);
}

.toggle-group__option {
  background: transparent;
  border: none;
  border-radius: var(--border-radius-small);
  color: var(--s-600);
  cursor: pointer;
  font-size: var(--font-size-mini);
  padding: var(--space-micro) var(--space-small);

  &--active {
    background: var(--white);
    color: var(--b-600);
    font-weight: var(--font-weight-bold);
  }
}

.loss-reasons-empty {
  align-items: center;
  display: flex;
  gap: var(--space-normal);
  padding: var(--space-normal) 0;
}

.loss-reasons-empty__image {
  height: 8rem;
  width: 8rem;
}

.loss-reasons-empty__title {
  font-weight: var(--font-weight-bold);
  margin: 0 0 var(--space-micro);
}

.loss-reasons-empty__message {
  color: var(--s-500);
  font-size: var(--font-size-small);
  margin: 0;
}
</style>
